import { JSX } from "react"

import "./rotate-phone.css"
import src from "./rotate-phone.gif"

export default function RotatePhone(): JSX.Element {
  return <img src={src} alt="rotate your phone" id="rotate-your-phone" />
}
